var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/system';
import { gray30, gray35, gray40, gray40opacity30, gray50, gray70 } from '../../../colors/gray';
import { neutral60opacity15 } from '../../../colors/neutral';
import { grid as gridDarkStyles } from '../grid/grid';
export var MuiCssBaseline = {
    styleOverrides: __assign({ 
        /* Firefox scrollbar styles*/
        '*': {
            scrollbarWidth: 'thin',
            scrollbarColor: "".concat(gray40opacity30, " transparent"),
        }, 
        /* Chromium scrollbar styles*/
        '::-webkit-scrollbar-corner': {
            backgroundColor: 'transparent',
        }, '::-webkit-scrollbar:hover': {
            backgroundColor: neutral60opacity15,
        }, '::-webkit-scrollbar-thumb': {
            backgroundColor: gray40opacity30,
        }, '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: gray50,
        }, '::-webkit-scrollbar-thumb:active': {
            backgroundColor: gray30,
        }, '.apexcharts-xaxis': { '& line': { stroke: gray40 } }, '.apexcharts-xaxis-label': { fill: gray35 }, '.apexcharts-xaxis-tick': { stroke: gray40 }, '.apexcharts-yaxis': { '& line': { stroke: gray40 } }, '.apexcharts-yaxis-label': { fill: gray35 }, 'div.apexcharts-tooltip.apexcharts-tooltip': {
            backgroundColor: alpha(gray70, 0.95),
        } }, gridDarkStyles),
};
